function initCalendarPlanningDemo(config) {
  config = config || {};
  const today = new Date();
  const systemYear = today.getFullYear();
  const todayDateString = today.toDateString();
  let currentYear = Number.isInteger(config.year) ? config.year : systemYear;
  let startDayOfWeek = Number.isInteger(config.startDayOfWeek) ? config.startDayOfWeek : 0;

  const calendarContainer = document.querySelector("#calendar");
  const currentYearSpan = document.getElementById("currentYear");
  const currentYearLive = document.getElementById("calendarYearLive");
  const currentYearButton = document.getElementById("currentYearButton");
  const calendarTodayButton = document.getElementById("calendarTodayButton");
  const startDaySelect = document.getElementById("startDaySelect");
  const prevYearButton = document.getElementById("prevYear");
  const nextYearButton = document.getElementById("nextYear");

  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  let monthTables = {};
  let monthStats = {};
  const quarterStatsRefs = {};
  const yearStatsRefs = {};

  monthNames.forEach(monthName => {
    monthTables[monthName] = document.querySelector(`#${monthName}-table table.calendar`);
    monthStats[monthName] = {
      monthTotaldays: document.querySelector(`#${monthName}-stats .monthTotaldays`),
      monthWorkdays: document.querySelector(`#${monthName}-stats .monthWorkdays`),
      monthOffdays: document.querySelector(`#${monthName}-stats .monthOffdays`),
      monthHolidays: document.querySelector(`#${monthName}-stats .monthHolidays`),
      monthEventDays: document.querySelector(`#${monthName}-stats .monthEventDays`),
      monthVacationDays: document.querySelector(`#${monthName}-stats .monthVacationDays`),
      monthWeekends: document.querySelector(`#${monthName}-stats .monthWeekends`),
      monthWeekdaysTotal: document.querySelector(`#${monthName}-stats .monthWeekdaysTotal`),
      monthWeekdaysOn: document.querySelector(`#${monthName}-stats .monthWeekdaysOn`),
      monthWeekdaysOff: document.querySelector(`#${monthName}-stats .monthWeekdaysOff`),
      monthPlanningDays: document.querySelector(`#${monthName}-stats .monthPlanningDays`),
      monthReleaseDays: document.querySelector(`#${monthName}-stats .monthReleaseDays`),
      monthDevelopmentDays: document.querySelector(`#${monthName}-stats .monthDevelopmentDays`),
    };
  });

  ['Q1', 'Q2', 'Q3', 'Q4'].forEach(function(quarterName) {
    const root = document.getElementById(quarterName);
    if (!root) return;
    quarterStatsRefs[quarterName] = {
      quarterTotaldays: root.querySelector('.quarterTotaldays'),
      quarterWorkdays: root.querySelector('.quarterWorkdays'),
      quarterOffdays: root.querySelector('.quarterOffdays'),
      quarterHolidays: root.querySelector('.quarterHolidays'),
      quarterEventDays: root.querySelector('.quarterEventDays'),
      quarterReleaseDays: root.querySelector('.quarterReleaseDays'),
      quarterVacationDays: root.querySelector('.quarterVacationDays'),
      quarterPlanningDays: root.querySelector('.quarterPlanningDays'),
      quarterDevelopmentDays: root.querySelector('.quarterDevelopmentDays'),
      quarterWeekends: root.querySelector('.quarterWeekends'),
      quarterWeekdaysTotal: root.querySelector('.quarterWeekdaysTotal'),
      quarterWeekdaysOn: root.querySelector('.quarterWeekdaysOn'),
      quarterWeekdaysOff: root.querySelector('.quarterWeekdaysOff')
    };
  });

  [
    'yearTotaldays',
    'yearWorkdays',
    'yearOffdays',
    'yearHolidays',
    'yearEventDays',
    'yearVacationDays',
    'yearWeekends',
    'yearWeekdaysTotal',
    'yearWeekdaysOn',
    'yearWeekdaysOff',
    'yearPlanningDays',
    'yearReleaseDays',
    'yearDevelopmentDays'
  ].forEach(function(id) {
    yearStatsRefs[id] = document.getElementById(id);
  });
  
  const defaultHolidays = [
    { rule: 'fixed', date: '01-01', name: 'New Year\'s Day' },
    { rule: 'nthWeekdayOfMonth', month: 0, nth: 3, weekday: 1, name: 'Martin Luther King Jr. Day' },
    { rule: 'nthWeekdayOfMonth', month: 1, nth: 3, weekday: 1, name: 'President\'s Day' },
    { rule: 'fixed', date: '02-14', name: 'Valentine\'s Day' },
    { rule: 'fixed', date: '02-29', name: 'Leap Year Day' },
    { rule: 'fixed', date: '03-17', name: 'St. Patrick\'s Day' },
    { rule: 'lastWeekdayOfMonth', month: 4, weekday: 1, name: 'Memorial Day' },
    { rule: 'fixed', date: '04-20', name: 'Earth Day' },
    { rule: 'nthWeekdayOfMonth', month: 4, nth: 2, weekday: 0, name: 'Mother\'s Day' },
    { rule: 'fixed', date: '07-04', name: 'Independence Day' },
    { rule: 'nthWeekdayOfMonth', month: 5, nth: 3, weekday: 0, name: 'Father\'s Day' },
    { rule: 'nthWeekdayOfMonth', month: 7, nth: 1, weekday: 0, name: 'International Friendship Day' },
    { rule: 'nthWeekdayOfMonth', month: 8, nth: 1, weekday: 1, name: 'Labor Day' },
    { rule: 'fixed', date: '10-31', name: 'Halloween' },
    { rule: 'fixed', date: '11-11', name: 'Veteran\'s Day' },
    { rule: 'nthWeekdayOfMonth', month: 10, nth: 4, weekday: 4, name: 'Thanksgiving Day' },
    { rule: 'fixed', date: '12-24', name: 'Christmas Eve' },
    { rule: 'fixed', date: '12-25', name: 'Christmas Day' },
    { rule: 'fixed', date: '12-31', name: 'New Year\'s Eve' }
  ];

  const defaultEvents = [
    { start: '2024-04-15', end: '2024-04-19', name: 'Company Retreat' }
  ];

  const defaultVacations = [
    { start: '01-01', end: '01-03', name: 'Q4 Vacation (Part 2)' },
    { start: '06-23', end: '06-30', name: 'Q2 Vacation (Part 1)' },
    { start: '07-01', end: '07-07', name: 'Q2 Vacation (Part 2)' },
    { start: '12-19', end: '12-31', name: 'Q4 Vacation (Part 1)' }
  ];

  const holidays = Array.isArray(config.holidays) ? config.holidays : defaultHolidays;
  const events = Array.isArray(config.events) ? config.events : defaultEvents;
  const vacations = Array.isArray(config.vacations) ? config.vacations : defaultVacations;

  if (startDaySelect) {
    startDaySelect.value = String(startDayOfWeek);
  }

  let yearCache = null;
  let monthStatsCache = {};

  function dateKey(date) {
    return date.toISOString().split('T')[0];
  }

  function addMapValue(map, key, value) {
    if (!map.has(key)) {
      map.set(key, []);
    }
    map.get(key).push(value);
  }

  function getHolidayDate(year, holiday) {
    if (holiday.rule === 'fixed') {
      return new Date(year, parseInt(holiday.date.split('-')[0]) - 1, parseInt(holiday.date.split('-')[1]));
    } else if (holiday.rule === 'nthWeekdayOfMonth') {
      let date = new Date(year, holiday.month, 1);
      let weekdayCount = 0;
      while (true) {
        if (date.getDay() === holiday.weekday) {
          weekdayCount++;
          if (weekdayCount === holiday.nth) {
            return date;
          }
        }
        date.setDate(date.getDate() + 1);
      }
    } else if (holiday.rule === 'lastWeekdayOfMonth') {
      let date = new Date(year, holiday.month + 1, 0);
      while (date.getDay() !== holiday.weekday) {
        date.setDate(date.getDate() - 1);
      }
      return date;
    }
  }

  let planningDays = [];

  function calculatePlanningDays(year, baseLookup) {
    planningDays = [];

    function getFirstNWorkdays(year, month, n) {
      let date = new Date(year, month, 1);
      const workdays = [];
      while (workdays.length < n) {
        const key = dateKey(date);
        if (date.getDay() !== 0 && date.getDay() !== 6 && !baseLookup.holidaySet.has(key) && !baseLookup.vacationSet.has(key)) {
          workdays.push(key);
        }
        date.setDate(date.getDate() + 1);
      }
      return workdays;
    }

    const quarters = [
      { name: 'Q1 Planning', months: [0, 1, 2] },
      { name: 'Q2 Planning', months: [3, 4, 5] },
      { name: 'Q3 Planning', months: [6, 7, 8] },
      { name: 'Q4 Planning', months: [9, 10, 11] }
    ];

    quarters.forEach(quarter => {
      const firstMonth = quarter.months[0];
      const planningDaysArray = getFirstNWorkdays(year, firstMonth, 10);
      planningDaysArray.forEach(day => planningDays.push({ start: day, end: day, name: quarter.name }));
    });
  }

  calculatePlanningDays(currentYear, { holidaySet: new Set(), vacationSet: new Set() });

  let releases = [];

  function calculateReleaseDays(year, baseLookup) {
    releases = [];

    function getLastNWorkdays(year, month, n) {
      let date = new Date(year, month + 1, 0);
      const workdays = [];
      while (workdays.length < n) {
        const key = dateKey(date);
        if (date.getDay() !== 0 && date.getDay() !== 6 && !baseLookup.holidaySet.has(key) && !baseLookup.vacationSet.has(key)) {
          workdays.unshift(key);
        }
        date.setDate(date.getDate() - 1);
      }
      return workdays;
    }

    const quarters = [
      { name: 'Q1 Release', months: [0, 1, 2] },
      { name: 'Q2 Release', months: [3, 4, 5] },
      { name: 'Q3 Release', months: [6, 7, 8] },
      { name: 'Q4 Release', months: [9, 10, 11] }
    ];

    quarters.forEach(quarter => {
      const lastMonth = quarter.months[quarter.months.length - 1];
      const releaseDays = getLastNWorkdays(year, lastMonth, 10);
      releaseDays.forEach(day => releases.push({ start: day, end: day, name: quarter.name }));
    });
  }

  calculateReleaseDays(currentYear, { holidaySet: new Set(), vacationSet: new Set() });

  function buildYearCache(year) {
    const holidayMap = new Map();
    const vacationMap = new Map();
    const eventMap = new Map();

    holidays.forEach(holiday => {
      const holidayDate = getHolidayDate(year, holiday);
      if (!holidayDate) return;
      addMapValue(holidayMap, dateKey(holidayDate), holiday.name);
    });

    vacations.forEach(vacation => {
      let cursor = new Date(`${year}-${vacation.start}`);
      const end = new Date(`${year}-${vacation.end}`);
      while (cursor <= end) {
        addMapValue(vacationMap, dateKey(cursor), vacation.name);
        cursor.setDate(cursor.getDate() + 1);
      }
    });

    events.forEach(event => {
      let cursor = new Date(event.start);
      const end = new Date(event.end);
      while (cursor <= end) {
        addMapValue(eventMap, dateKey(cursor), event.name);
        cursor.setDate(cursor.getDate() + 1);
      }
    });

    const baseLookup = {
      holidaySet: new Set(holidayMap.keys()),
      vacationSet: new Set(vacationMap.keys())
    };

    calculatePlanningDays(year, baseLookup);
    calculateReleaseDays(year, baseLookup);

    const planningMap = new Map();
    const releaseMap = new Map();
    planningDays.forEach(item => addMapValue(planningMap, item.start, item.name));
    releases.forEach(item => addMapValue(releaseMap, item.start, item.name));

    yearCache = {
      year,
      holidayMap,
      holidaySet: new Set(holidayMap.keys()),
      vacationMap,
      vacationSet: new Set(vacationMap.keys()),
      eventMap,
      eventSet: new Set(eventMap.keys()),
      planningMap,
      planningSet: new Set(planningMap.keys()),
      releaseMap,
      releaseSet: new Set(releaseMap.keys())
    };
    monthStatsCache = {};
  }

  function ensureYearCache(year) {
    if (!yearCache || yearCache.year !== year) {
      buildYearCache(year);
    }
  }

  function updateStats(year, monthIndex) {
    ensureYearCache(year);
    if (monthStatsCache[monthIndex]) {
      return monthStatsCache[monthIndex];
    }

    let totalDays = 0;
    let workdays = 0;
    let offdays = 0;
    let holidaysCount = 0;
    let eventDays = 0;
    let vacationDays = 0;
    let weekends = 0;
    let weekdaysTotal = 0;
    let weekdaysOn = 0;
    let weekdaysOff = 0;
    let planningDaysCount = 0;
    let releaseDays = 0;
    let developmentDays = 0;

    let firstDayOfMonth = new Date(year, monthIndex, 1);
    let lastDayOfMonth = new Date(year, monthIndex + 1, 0);
    let date = firstDayOfMonth;

    while (date <= lastDayOfMonth) {
      let isWeekend = (date.getDay() === 0 || date.getDay() === 6);
      const key = dateKey(date);
      let isHoliday = yearCache.holidaySet.has(key);
      let isVacation = yearCache.vacationSet.has(key);
      let isEvent = yearCache.eventSet.has(key);
      let isPlanningDay = yearCache.planningSet.has(key);
      if (isPlanningDay) {
        planningDaysCount++; // Add this line
      }
      let isRelease = yearCache.releaseSet.has(key);
      let isDevelopmentDay = !isWeekend && !isHoliday && !isEvent && !isRelease && !isVacation && !isPlanningDay; // Add this line
      if (isDevelopmentDay) {
        developmentDays++; // Add this line
      }

      totalDays++;
      if (!isWeekend) {
        weekdaysTotal++;
        if (!isHoliday && !isVacation) {
          weekdaysOn++;
        } else if (!isEvent) {
          weekdaysOff++;
        }
      }
      if (isEvent) {
        eventDays++;
      } 
      if (!isWeekend && !isHoliday && !isVacation) {
        workdays++;
      } else if (!isEvent) {
        offdays++;
      }
      if (isWeekend) weekends++;
      if (isHoliday) holidaysCount++;
      if (isVacation) vacationDays++;
      if (isRelease) releaseDays++;

      date.setDate(date.getDate() + 1);
    }

    const result = { totalDays, workdays, offdays, holidaysCount, eventDays, vacationDays, weekends, weekdaysTotal, weekdaysOn, weekdaysOff, planningDaysCount, releaseDays, developmentDays };
    monthStatsCache[monthIndex] = result;
    return result;
  }

  function updateYearStats(year) {
    let yearTotalDays = 0;
    let yearWorkdays = 0;
    let yearOffdays = 0;
    let yearHolidays = 0;
    let yearEventDays = 0;
    let yearVacationDays = 0;
    let yearWeekends = 0;
    let yearWeekdaysTotal = 0;
    let yearWeekdaysOn = 0;
    let yearWeekdaysOff = 0;
    let yearPlanningDays = 0;
    let yearReleaseDays = 0;
    let yearDevelopmentDays = 0;

    monthNames.forEach((monthName, monthIndex) => {
      let stats = updateStats(year, monthIndex);
      yearTotalDays += stats.totalDays;
      yearWorkdays += stats.workdays;
      yearOffdays += stats.offdays;
      yearHolidays += stats.holidaysCount;
      yearEventDays += stats.eventDays;
      yearVacationDays += stats.vacationDays;
      yearWeekends += stats.weekends;
      yearWeekdaysTotal += stats.weekdaysTotal;
      yearWeekdaysOn += stats.weekdaysOn;
      yearWeekdaysOff += stats.weekdaysOff;
      yearPlanningDays += stats.planningDaysCount;
      yearReleaseDays += stats.releaseDays;
      yearDevelopmentDays += stats.developmentDays;
    });

    let isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    let leapYearText = isLeapYear ? " (Leap Year)" : "";

    yearStatsRefs.yearTotaldays.textContent = `${yearTotalDays}${leapYearText}`;
    yearStatsRefs.yearWorkdays.textContent = yearWorkdays;
    yearStatsRefs.yearOffdays.textContent = yearOffdays;
    yearStatsRefs.yearHolidays.textContent = yearHolidays;
    yearStatsRefs.yearEventDays.textContent = yearEventDays;
    yearStatsRefs.yearVacationDays.textContent = yearVacationDays;
    yearStatsRefs.yearWeekends.textContent = yearWeekends;
    yearStatsRefs.yearWeekdaysTotal.textContent = yearWeekdaysTotal;
    yearStatsRefs.yearWeekdaysOn.textContent = yearWeekdaysOn;
    yearStatsRefs.yearWeekdaysOff.textContent = yearWeekdaysOff;
    yearStatsRefs.yearPlanningDays.textContent = yearPlanningDays;
    yearStatsRefs.yearReleaseDays.textContent = yearReleaseDays;
    yearStatsRefs.yearDevelopmentDays.textContent = yearDevelopmentDays;
  }

  function updateQuarterStats(year) {
    const quarters = [
      { name: 'Q1', months: [0, 1, 2] },
      { name: 'Q2', months: [3, 4, 5] },
      { name: 'Q3', months: [6, 7, 8] },
      { name: 'Q4', months: [9, 10, 11] }
    ];

    quarters.forEach(quarter => {
      let totalDays = 0;
      let workdays = 0;
      let offdays = 0;
      let holidays = 0;
      let eventDays = 0;
      let releaseDays = 0;
      let vacationDays = 0;
      let planningDays = 0;
      let developmentDays = 0;
      let weekends = 0;
      let weekdaysTotal = 0;
      let weekdaysOn = 0;
      let weekdaysOff = 0;

      quarter.months.forEach(monthIndex => {
        let stats = updateStats(year, monthIndex);
        totalDays += stats.totalDays;
        workdays += stats.workdays;
        offdays += stats.offdays;
        holidays += stats.holidaysCount;
        eventDays += stats.eventDays;
        releaseDays += stats.releaseDays;
        vacationDays += stats.vacationDays;
        planningDays += stats.planningDaysCount;
        developmentDays += stats.developmentDays;
        weekends += stats.weekends;
        weekdaysTotal += stats.weekdaysTotal;
        weekdaysOn += stats.weekdaysOn;
        weekdaysOff += stats.weekdaysOff;
      });

      const refs = quarterStatsRefs[quarter.name];
      refs.quarterTotaldays.textContent = totalDays;
      refs.quarterWorkdays.textContent = workdays;
      refs.quarterOffdays.textContent = offdays;
      refs.quarterHolidays.textContent = holidays;
      refs.quarterEventDays.textContent = eventDays;
      refs.quarterReleaseDays.textContent = releaseDays;
      refs.quarterVacationDays.textContent = vacationDays;
      refs.quarterPlanningDays.textContent = planningDays;
      refs.quarterDevelopmentDays.textContent = developmentDays;
      refs.quarterWeekends.textContent = weekends;
      refs.quarterWeekdaysTotal.textContent = weekdaysTotal;
      refs.quarterWeekdaysOn.textContent = weekdaysOn;
      refs.quarterWeekdaysOff.textContent = weekdaysOff;
    });
  }

  function generateCalendar(year) {
    ensureYearCache(year);
    currentYearSpan.textContent = year;
    if (currentYearLive) {
      currentYearLive.textContent = String(year);
    }
    updateYearStats(year);
    updateQuarterStats(year);

    if (year === systemYear) {
      currentYearButton.title = "Go to today";
    } else {
      currentYearButton.title = "Go to the current year";
    }

    monthNames.forEach((monthName, monthIndex) => {
      const monthTable = monthTables[monthName];
      const {
        monthTotaldays,
        monthWorkdays,
        monthOffdays,
        monthHolidays,
        monthEventDays,
        monthVacationDays,
        monthWeekends,
        monthWeekdaysTotal,
        monthWeekdaysOn,
        monthWeekdaysOff,
        monthPlanningDays,
        monthReleaseDays,
        monthDevelopmentDays,
      } = monthStats[monthName];
      
      const thead = document.createElement("thead");
      const tbody = document.createElement("tbody");

      monthTable.innerHTML = "";
      monthTable.appendChild(thead);
      monthTable.appendChild(tbody);

      const theadRow = document.createElement("tr");
      for (let i = 0; i < 7; i++) {
        const th = document.createElement("th");
        th.textContent = dayNames[(i + startDayOfWeek) % 7];
        theadRow.appendChild(th);
      }
      thead.appendChild(theadRow);

      let firstDayOfMonth = new Date(year, monthIndex, 1);
      let lastDayOfMonth = new Date(year, monthIndex + 1, 0);
      let date = firstDayOfMonth;
      let row = tbody.insertRow();

      // Add empty cells for days before the first day of the month
      for (let i = 0; i < (firstDayOfMonth.getDay() - startDayOfWeek + 7) % 7; i++) {
        let cell = row.insertCell();
        cell.classList.add("blank");
      }

      while (date <= lastDayOfMonth) {
        if (row.cells.length >= 7) {
          row = tbody.insertRow();
        }

        let cell = row.insertCell();
        cell.innerHTML = `<div class="cell-content">${date.getDate()}</div>`;
        cell.dataset.date = dateKey(date);
        let cellContent = cell.querySelector(".cell-content");

        if (date.getDay() === 0 || date.getDay() === 6) {
          cell.classList.add('weekend');
        }

        if (date.toDateString() === todayDateString) {
          cell.classList.add('today');
          cell.id = 'calendar-today';
          let todayTooltip = document.createElement("div");
          todayTooltip.classList.add("tooltip");
          todayTooltip.textContent = "Today";
          cellContent.appendChild(todayTooltip);
        }

        const holidayNames = yearCache.holidayMap.get(cell.dataset.date);
        if (holidayNames) {
          holidayNames.forEach(name => {
            let bar = document.createElement("div");
            bar.classList.add('calendar-bar', 'holiday');
            bar.innerHTML = `<div class="tooltip">${name}</div>`;
            cellContent.appendChild(bar);
          });
        }

        const vacationNames = yearCache.vacationMap.get(cell.dataset.date);
        if (vacationNames) {
          vacationNames.forEach(name => {
            let bar = document.createElement("div");
            bar.classList.add('calendar-bar', 'vacation');
            bar.innerHTML = `<div class="tooltip">${name}</div>`;
            cellContent.appendChild(bar);
          });
        }

        const eventNames = yearCache.eventMap.get(cell.dataset.date);
        if (eventNames) {
          eventNames.forEach(name => {
            let bar = document.createElement("div");
            bar.classList.add('calendar-bar', 'event');
            bar.innerHTML = `<div class="tooltip">${name}</div>`;
            cellContent.appendChild(bar);
          });
        }

        const planningNames = yearCache.planningMap.get(cell.dataset.date);
        if (planningNames) {
          planningNames.forEach(name => {
            let bar = document.createElement("div");
            bar.classList.add('calendar-bar', 'planning');
            bar.innerHTML = `<div class="tooltip">${name}</div>`;
            cellContent.appendChild(bar);
          });
        }

        const releaseNames = yearCache.releaseMap.get(cell.dataset.date);
        if (releaseNames) {
          releaseNames.forEach(name => {
            let bar = document.createElement("div");
            bar.classList.add('calendar-bar', 'release');
            bar.innerHTML = `<div class="tooltip">${name}</div>`;
            cellContent.appendChild(bar);
          });
        }

        date.setDate(date.getDate() + 1);
      }

      // Add empty cells for days after the last day of the month
      while (row.cells.length < 7) {
        let cell = row.insertCell();
        cell.classList.add("blank");
      }

      // Calculate the total number of rows needed based on the assumption the first day of the month is on a Saturday
      let totalDays = lastDayOfMonth.getDate();
      let totalCells = 6 + totalDays; // Assume the first day is on a Saturday
      let totalRows = Math.ceil(totalCells / 7);

      // Ensure there are the required number of rows
      while (tbody.rows.length < totalRows) {
        row = tbody.insertRow();
        for (let i = 0; i < 7; i++) {
          let cell = row.insertCell();
          cell.classList.add("blank");
        }
      }

      // Add the blank-row class to entirely blank rows
      for (let i = 0; i < tbody.rows.length; i++) {
        let isBlankRow = true;
        for (let j = 0; j < tbody.rows[i].cells.length; j++) {
          if (!tbody.rows[i].cells[j].classList.contains("blank")) {
            isBlankRow = false;
            break;
          }
        }
        if (isBlankRow) {
          tbody.rows[i].classList.add("blank-row");
        }
      }

      // Update month stats
      let stats = updateStats(year, monthIndex);
      monthTotaldays.textContent = stats.totalDays;
      monthWorkdays.textContent = stats.workdays;
      monthOffdays.textContent = stats.offdays;
      monthHolidays.textContent = stats.holidaysCount;
      monthEventDays.textContent = stats.eventDays;
      monthVacationDays.textContent = stats.vacationDays;
      monthWeekends.textContent = stats.weekends;
      monthWeekdaysTotal.textContent = stats.weekdaysTotal;
      monthWeekdaysOn.textContent = stats.weekdaysOn;
      monthWeekdaysOff.textContent = stats.weekdaysOff;
      monthPlanningDays.textContent = stats.planningDaysCount;
      monthReleaseDays.textContent = stats.releaseDays;
      monthDevelopmentDays.textContent = stats.developmentDays;
    });
  }


  prevYearButton.addEventListener("click", function() {
    currentYear--;
    generateCalendar(currentYear);
  });

  nextYearButton.addEventListener("click", function() {
    currentYear++;
    generateCalendar(currentYear);
  });

  currentYearButton.addEventListener("click", function() {
    // Scroll to today's cell
    const todayCell = document.querySelector('.today');
    if (todayCell) {
      todayCell.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      currentYear = systemYear;
      generateCalendar(currentYear);
    }
  });

  if (calendarTodayButton) {
    calendarTodayButton.addEventListener("click", function(event) {
      event.preventDefault();

      if (currentYear !== systemYear) {
        currentYear = systemYear;
        generateCalendar(currentYear);
      }

      const todayCell = document.getElementById('calendar-today');
      if (todayCell) {
        todayCell.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  startDaySelect.addEventListener("change", function() {
    startDayOfWeek = parseInt(this.value);
    generateCalendar(currentYear);
  });

  generateCalendar(currentYear);
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = initCalendarPlanningDemo;
}

if (typeof window !== 'undefined') {
  window.initCalendarPlanningDemo = initCalendarPlanningDemo;
}


